import { finalize } from 'rxjs/operators';
import { ticketRequestError } from '../../ticket-form.utils';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { TicketCategoryService } from 'src/app/Service/TicketCategory/TicketCategory.service';

@Component({
  selector: 'app-TicketCategoryList',
  templateUrl: './TicketCategoryList.component.html',
  styleUrls: ['./TicketCategoryList.component.scss', '../../ticket-shared.css']
})
export class TicketCategoryListComponent implements OnInit {
  ErrorMessage = '';
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private TicketCategory_Service:TicketCategoryService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_TicketCategory:Array<General_Interface>=[]
  Data_Seleted_Delete:General_Interface=Empty_General_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1113).subscribe(
      data=>{
        this.ReadData_TicketCategory()
      }
      ,error=>{
        this.ErrorMessage = ticketRequestError(error); this.Alertify_Service.ErrorMessage(this.ErrorMessage);
      }
    )

    
  }

  ReadData_TicketCategory(){
    if (this.Procssing) return;
    this.ErrorMessage = '';
    this.Procssing=true
    this.TicketCategory_Service.GetRecord().pipe(finalize(() => this.Procssing = false)).subscribe(
      data=>{
        this.DataList_TicketCategory=data
        this.Procssing=false
      },error=>{
        this.ErrorMessage = ticketRequestError(error); this.Alertify_Service.ErrorMessage(this.ErrorMessage);

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:General_Interface){
    if (item.DeletingProccess) return;
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.TicketCategory_Service.DeleteTicketCategory(item.id).pipe(finalize(() => item.DeletingProccess = false)).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")
        this.ReadData_TicketCategory()
      },error=>{
        this.ErrorMessage = ticketRequestError(error); this.Alertify_Service.ErrorMessage(this.ErrorMessage);

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
